export default __webpack_public_path__ + "static/media/11.13182a4c.svg";